import Errors from './Errors';
// import { globalStorage } from '../store/index';

class Http {
    /**
     * Create a new Http instance.
     *
     * @param {type} dataType
     * @param {object} data
     */
    constructor(dataType = Object, data = null) {
        this.originalData = data;
        this.dataType = dataType;
        for(const field in data) {
            this[field] = data[field];
        }
        this.errors = new Errors();
    }


    /**
     * Fetch all relevant data for the form.
     */
    dataObject() {
        const data = {};
        for(const property in this.originalData) {
            data[property] = this[property];
            if('string' === typeof(this[property])) {
                data[property] = TextTransform.trimSpaces(data[property]);
            }
        }
        return data;
    }


    /**
     * Fetch all relevant data for the form.
     */
    dataForm() {
        const data = new FormData();
        for(const property in this.originalData) {
            if('string' === typeof(this[property])) {
                data[property] = TextTransform.trimSpaces(data[property]);
            }
            data.append(property, this[property]);
        }
        return data;
    }


    /**
     * Fetch all relevant data for the form.
     */
    getData() {
        let data;
        switch(this.dataType) {
            case FormData:
                data = this.dataForm();
                break;
            default:
                data = this.dataObject();
        }
        return data;
    }


    /**
     * Reset the form fields.
     */
    reset(all = false) {
        if(all) {
            for(const field in this.originalData) {
                this[field] = Test.isString(this[field]) ? '' : null;
            }
        }
        this.errors.clear();
    }


    /**
     * Send a HEAD request to the given URL.
     *
     * @param {string} server URL that will be used for the request
     * @param {object} custom headers to be sent
     */
    head(url, headers = null) {
        return this.submit('head', url, null, headers);
    }


    /**
     * Send a GET request to the given URL.
     *
     * @param {string} server URL that will be used for the request
     * @param {object} custom headers to be sent
     * @param {object|URLSearchParams} URL parameters to be sent with the request
     */
    get(url, headers = null, params = null) {
        return this.submit('get', url, null, headers, params);
    }


    /**
     * Send a POST request to the given URL.
     *
     * @param {string} server URL that will be used for the request
     * @param {object} custom headers to be sent
     * @param {object|URLSearchParams} URL parameters to be sent with the request
     */
    post(url, headers = null, params = null) {
        return this.submit('post', url, this.getData(), headers, params);
    }


    /**
     * Send a PUT request to the given URL.
     *
     * @param {string} server URL that will be used for the request
     * @param {object} custom headers to be sent
     * @param {object|URLSearchParams} URL parameters to be sent with the request
     */
    put(url, headers = null, params = null) {
        return this.submit('put', url, this.getData(), headers, params);
    }


    /**
     * Send a PATCH request to the given URL.
     *
     * @param {string} server URL that will be used for the request
     * @param {object} custom headers to be sent
     * @param {object|URLSearchParams} URL parameters to be sent with the request
     */
    patch(url, headers = null, params = null) {
        return this.submit('patch', url, this.getData(), headers, params);
    }


    /**
     * Send a DELETE request to the given URL.
     *
     * @param {string} server URL that will be used for the request
     * @param {object} custom headers to be sent
     * @param {object|URLSearchParams} URL parameters to be sent with the request
     */
    delete(url, headers = null, params = null) {
        return this.submit('delete', url, null, headers, params);
    }


    /**
     * Create a DELETE request to be sent using all().
     *
     * @param {string} server URL that will be used for the request
     * @param {object} custom headers to be sent
     * @param {object|URLSearchParams} URL parameters to be sent with the request
     */
    deletePromise(url, headers = null, params = null) {
        return axios({
                    method: 'delete',
                    url: url,
                    data: null,
                    headers: headers,
                    params: params
                });
    }


    /**
     * Send multiple concurrent requests.
     *
     * @param {array} iterable
     */
    all(promises) {
        return new Promise((resolve, reject) => {
            // https://github.com/axios/axios#request-config
            axios.all(promises)
            // handle the success case
            .then((response) => {
                this.onSuccess();
                resolve(response.data); // pass it along
            })
            // handle errors
            .catch((error) => {
                this.onFail(error.response.data.errors);
                reject(error.response.data); // pass it along
            });
        });
    }

    /**
     * Submit the form.
     *
     * @param {string} request method to be used when making the request
     * @param {string} server URL that will be used for the request
     * @param {object|FormData|File|Blob} data to be sent as the request body
     * @param {object} custom headers to be sent
     * @param {object|URLSearchParams} URL parameters to be sent with the request
     */
    submit(requestType, url, data, headers = null, params = null) {
        if(process.env.NODE_ENV === 'production') {
            url = url.replace(/^http\b/, 'https');
        }
        return (async() => new Promise(
            (resolve, reject) => {
                // https://github.com/axios/axios#request-config
                axios({
                    method: requestType,
                    maxRedirects: 0,
                    data,
                    headers,
                    params,
                    url,
                })
                // handle the success case
                .then((response) => {
                    this.onSuccess();
                    // Redirect não chega para o AXIOS...
                    // https://github.com/axios/axios/issues/674#issuecomment-279225530
                    if('location' in response.headers) {
                        // redirection
                        if(response.headers.location.charAt(0) === '/') {
                            window.location.href = response.headers.location;
                        }
                        else {
                            window.location = response.headers.location;
                        }
                    }
                    else {
                        // pass it along
                        resolve(response.data);
                    }
                })
                // handle errors
                .catch((error) => {
                    this.onFail(error);
                    // pass it along
                    if(error.response && error.response.data) {
                        reject(error.response.data);
                    }
                    else if(error.response) {
                        reject(error.response);
                    }
                    else {
                        reject(error);
                    }
                });
            })
        )();
    }


    /**
     * Handle a successful form submission.
     */
    onSuccess() {
        this.reset();
    }


    /**
     * Handle a failed form submission.
     *
     * @param {object} errors
     */
    onFail(error) {
        if(error.response && error.response.data && error.response.data.errors) {
            this.errors.record(error.response.data.errors);
        }
    }
}

export default Http;
